import { currencyOptions } from "../Settings/Data/lists";

// Shared currency helpers for purchase-order vendor amounts/prices.
// A vendor's orderAmount is persisted as a single string like "1234.50 USD".

export const DEFAULT_CURRENCY = "USD";
export const KNOWN_CURRENCIES = currencyOptions.map((c) => c.value);

// Split "1234.50 USD" into { amount, currency }. If no recognized currency
// suffix is present, fall back to the default currency.
export const parseOrderAmount = (raw) => {
  if (raw === undefined || raw === null || raw === "") {
    return { amount: "", currency: DEFAULT_CURRENCY };
  }
  const parts = String(raw).trim().split(/\s+/);
  const last = parts[parts.length - 1]?.toUpperCase();
  if (parts.length > 1 && KNOWN_CURRENCIES.includes(last)) {
    return { amount: parts.slice(0, -1).join(" "), currency: last };
  }
  return { amount: String(raw).trim(), currency: DEFAULT_CURRENCY };
};

// Recombine into the stored "<amount> <currency>" form. Empty amount -> "".
export const formatOrderAmount = (amount, currency) => {
  const a =
    amount === undefined || amount === null ? "" : String(amount).trim();
  if (a === "") return "";
  return `${a} ${currency || DEFAULT_CURRENCY}`;
};
